<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  AdditionalPassengersComponent,
  UserBadgeComponent,
  VehicleUserModule,
  VEHICLE_USER_ID,
  VEHICLE_USER_TYPES,
} from '@/../refactor-dist/refactor-module';

import { VEHICLE_USER_MODULE } from '@/constants/modules';

const MAX_PASSENGERS = 4;

const additionalPassengerFilter = {
  id: VEHICLE_USER_ID.bookingSummary,
  type: VEHICLE_USER_TYPES.passenger,
};

export default {
  name: 'AdditionalPassengersView',

  components: {
    AdditionalPassengersComponent,
    UserBadgeComponent,
  },

  computed: {
    ...mapGetters(
      VEHICLE_USER_MODULE,
      {
        getAdditionalPassengers: VehicleUserModule.GETTERS.data,
        getAdditionalPassengersCount: VehicleUserModule.GETTERS.count,
      },
    ),

    additionalPassengersFiltered() {
      return this.getAdditionalPassengers(additionalPassengerFilter);
    },

    isDisabled() {
      const count = this.getAdditionalPassengersCount(additionalPassengerFilter);

      return count >= MAX_PASSENGERS;
    },
  },

  methods: {
    ...mapMutations(
      VEHICLE_USER_MODULE,
      {
        addPassenger: VehicleUserModule.MUTATIONS.add,
        removePassenger: VehicleUserModule.MUTATIONS.remove,
      },
    ),

    onAddPassenger(text) {
      this.addPassenger({ ...additionalPassengerFilter, data: text });
    },

    onRemovePassenger(passenger) {
      this.removePassenger(passenger);
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12 col-sm-8 col-md-6 col-xl-4">
      <AdditionalPassengersComponent
        :disabled="isDisabled"
        @input="onAddPassenger"
      />
      <UserBadgeComponent
        v-for="(passenger, index) in additionalPassengersFiltered"
        :key="`passenger${index}`"
        :text="passenger.data"
        class="mb-2 mr-2"
        @remove="onRemovePassenger(passenger)"
      />
    </div>
  </div>
</template>
